import { getCourses } from '@yandex-int/k-common/client/api/defs/get-courses';
import { FullCLesson } from '@yandex-int/k-common/typings';
import { useAppContext, useViewDeps } from 'platform-components';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useMount, useUnmount } from 'react-use';

import lessonActions from 'common.components/lesson/actions';
import { actions as coursesActions } from 'store/courses/actions';

import { SpecCourseLessonViewContainer } from './lesson-view.container';

export const SpecCourseLessonSSRContainer = () => {
    const { initialRender, data } = useAppContext();
    const { classId } = useParams<{ classId: string }>();
    const dispatch = useDispatch();

    const courses = useViewDeps(getCourses, 'getCourses');
    const clessonWithResults = data.getFullClessonWithResults as FullCLesson;

    useMount(() => {
        if (initialRender) {
            if (clessonWithResults && clessonWithResults.clesson) {
                // @ts-ignore
                dispatch(lessonActions.setLesson({ lesson: clessonWithResults.clesson }));
                // @ts-ignore некорректные тайпинга на clessonWithResults.clessonResults
                dispatch(lessonActions.setCLessonResults({ results: clessonWithResults.clessonResults.data }));
            }
            if (courses) {
                dispatch(coursesActions.getCoursesByTeamSuccess({ teamId: parseInt(classId), courses }));
            }
        }
    });

    useUnmount(() => {
        dispatch(lessonActions.clearEditor());
    });

    return <SpecCourseLessonViewContainer />;
};
